import { Link, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb, Form, Layout, Result, Space, Spin } from 'antd';

import { Hooks, PageLayout } from '@app/web-components';
import { Common } from '@app/web-pages';

import { useEditProfile, useGetProfile } from '../data';
import { ProfileFormData, useProfileForm } from '../libs';

export const EditPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id || isNaN(+id)) {
    navigate('/404', { replace: false });
  }
  const profileId = +id;
  const { data: profile, isError, isLoading } = useGetProfile(profileId, { enabled: !!profileId });

  const edit = useEditProfile(+id);

  const initialValues: ProfileFormData = profile
    ? {
        worker: {
          label: profile?.user.name,
          value: profile?.user.enterpriseId,
        },
        node: {
          label: profile?.node.name,
          value: profile?.node.id,
        },
        project: {
          label: profile?.die.name,
          value: profile?.die.id,
        },
      }
    : {};

  const { getEditFormProps, getSuccessResultProps } = useProfileForm(edit, initialValues);
  const layoutContentProps = Hooks.useFormLayout();

  if (isLoading) {
    return <Spin style={{ width: '100%' }} />;
  }

  if (isError || !profile) {
    return <Common.NotFoundPage subTitle="Sorry, this profile does not exist or was deleted." />;
  }

  return (
    <Space direction="vertical" style={{ overflow: 'auto' }}>
      <Breadcrumb
        style={{ margin: '16px 0' }}
        items={[
          { title: <Link to="/">Home</Link> },
          { title: <Link to="../">Profiles</Link> },
          { title: 'Edit Profile' },
        ]}
      />
      <Layout.Content {...layoutContentProps}>
        <PageLayout.Title title="Edit Profile" />
        {isError || !profile ? (
          <Common.NotFoundPage subTitle="Sorry, this profile does not exist or was deleted." />
        ) : isLoading ? (
          <Spin style={{ width: '100%' }} />
        ) : edit.isSuccess ? (
          <Result {...getSuccessResultProps()} title="Successfully edited a profile!" />
        ) : (
          <Form {...getEditFormProps()} initialValues={initialValues} />
        )}
      </Layout.Content>
    </Space>
  );
};
